<template>
    <div id="voiceRecorder" class="px-1">
        <div v-if="!isRecording">
            <md-button class="actionBtn" @click="() => startRecord()">
                <md-icon style="color: #1e1e2d">mic</md-icon>
            </md-button>
        </div>
        <div v-else class="voice-record-phase">
            <a-progress
                :percent="Math.ceil((duration / maxSec) * 100)"
                class="voice-record-phase-progress"
                status="active"
            />
            <md-button class="actionBtn" @click="() => stopRecord()">
                <md-icon style="color: green">check</md-icon>
            </md-button>
            <md-button class="actionBtn" @click="() => stopRecord(true)">
                <md-icon style="color: red">stop</md-icon>
            </md-button>
        </div>
    </div>
</template>

<script>
import { getRecorder } from "./util/voiceRecorder";
import log2 from "../utils/log2";

const log = log2("VoiceRecorder");

export default {
    name: "VoiceRecorder",
    props: ["cb"],
    data() {
        return {
            isRecording: false,
            duration: 0,
            interval: null,
            maxSec: 60,
        };
    },
    methods: {
        startRecord() {
            if (this.isRecording) return;
            getRecorder().start();
            this.isRecording = true;
            this.interval = setInterval(() => this.duration++, 1000);
        },
        stopRecord(cancel = false) {
            if (!this.isRecording) return;
            getRecorder().stop(cancel ? () => {} : this.cb);
            this.isRecording = false;
            clearInterval(this.interval);
            this.duration = 0;
        },
    },
    watch: {
        duration(newVal, oldVal) {
            if (newVal >= this.maxSec) {
                getRecorder().stop(this.cb);
                this.isRecording = false;
                clearInterval(this.interval);
                this.duration = 0;
            }
        },
    },
    beforeDestroy() {
        getRecorder().stop(() => {});
        clearInterval(this.interval);
    },
};
</script>

<style lang="scss">
#voiceRecorder {
    position: absolute;
    z-index: 9999;
    left: 92px;
    bottom: 80px;

    .actionBtn {
        min-width: 24px;
        margin: 0;
    }

    .voice-record-phase {
        display: flex;
        align-items: center;
        justify-content: center;

        &-progress {
            margin-left: 6px;
            width: 20vw;
        }
    }

    .ant-progress-inner {
        background-color: #d9d9d9;
    }
}
</style>
